import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import LogoBWS from "../../img/bws-logo.svg";
import AboutImg from "../../img/about-img.webp";
import SiteDecor from "../../img/site-decor.webp"

function About({ aboutData }) {

    return (
        <>
            {aboutData && (
                <section className="relative mb-[60px] md:mb-[120px]" id="about">
                    <div className="container max-w-screen-xl mx-auto px-[15px]">
                        <div className="relative bg-[linear-gradient(280deg,#009064_15.38%,#3ac097_61.93%,#ece66a_100%)]
                            flex flex-col justify-between py-14 px-[15px] 
                            md:flex-row  md:gap-8 
                            lg:p-14 lg:gap-16 mb-[60px] xl:mb-[120px]">

                            <div className="flex flex-col  text-white ">
                                <h3 className="font-bold uppercase text-3xl mb-8 lg:text-[42px] xl:text-[52px] ">Про захід</h3>
                                
                                <p className="font-bold text-lg xl:text-2xl mb-6">
                                    Business Wisdom Summit — ключова подія про стійкість та розвиток бізнесу під час війни від бізнес/медіа бюро ekonomika+ і журналу «ТОП-100. Рейтинги найбільших». 
                                </p>

                                <ul class="list-disc pl-6 space-y-2 mb-10 text-left">
                                    <li>лідери, які трансформують кризу на можливості</li>
                                    <li>команди, що мислять категоріями системи, масштабування і довгої гри</li>
                                    <li>компанії, які не чекають стабільності, а створюють її</li>
                                    <li>бізнеси, що беруть відповідальність за свої команди, партнерства, галузі та країну</li>
                                </ul>
                            </div>

                            <div className="z-10 md:min-w-[50%] xl:min-w-[40%]">
                                <iframe className="w-full h-full min-h-[300px] min-h-full" src="https://www.youtube.com/embed/LHHY08jbV4g?si=WLDeMaRSyFo3HDy5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>

                            <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 
                                md:w-[350px] md:left-3/4 xl:left-[70%]">
                                <img src={SiteDecor} alt="decor" className="w-full"/>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    );

}

export default About